/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GuideVersionResource = core.serialization.object({
    id: core.serialization.string(),
    version: core.serialization.number(),
    content: core.serialization.string(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
});
